export default __webpack_public_path__ + "static/media/clusterconfiguration_openapi.85de529d.yaml";